<template>
  <div>
    <div>
      <div
        class="mwow-button-filled primary"
        @click="clickexport"
        v-debounce="1000"
      >
        导出
      </div>
    </div>
    <div class="searchBox">
      <common-search-form-wrapper :reset="handleSearchReset">
        <el-form size="mini" ref="form" :model="searchInfo">
          <el-row>
            <el-col :span="8">
              <el-form-item label="学员搜索:">
                <el-input
                  v-model="searchInfo.student_name"
                  placeholder="学员姓名/手机号"
                  @clear="handleSearch"
                  prefix-icon="el-icon-search"
                  clearable
                  @change="handleSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学员标签:">
                <el-select
                  v-model="searchInfo.student_types"
                  multiple
                  filterable
                  default-first-option
                  placeholder="请选择"
                  @change="handleSearch"
                >
                  <el-option label="无" key="0" :value="0"> </el-option>
                  <el-option label="临时" key="1" :value="1"> </el-option>
                  <el-option label="补课" key="3" :value="3"> </el-option>
                  <el-option label="体验" key="5" :value="5"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课时间:">
                <common-date-range-selector
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  v-model="searchInfo.lesson_date"
                  @change="handleSearch"
                >
                </common-date-range-selector>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签到状态:">
                <el-select
                  v-model="searchInfo.student_status_list"
                  multiple
                  filterable
                  default-first-option
                  placeholder="请选择"
                  @change="handleSearch"
                >
                  <el-option label="到课" key="1" :value="1"> </el-option>
                  <el-option label="迟到" key="2" :value="2"> </el-option>
                  <el-option label="请假" key="3" :value="3"> </el-option>
                  <el-option label="未到课" key="4" :value="4"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="班级名称:">
                <el-select
                  v-model.number="searchInfo.class_id"
                  filterable
                  clearable
                  placeholder="请选择班级"
                  @change="handleSearch"
                  @focus="globalSearch('', 'class')"
                  :filter-method="
                    (queryString) => {
                      globalSearch(queryString, 'class');
                    }
                  "
                >
                  <el-option
                    v-for="item in className"
                    :key="item.class_id"
                    :label="item.name"
                    :value="Number(item.class_id)"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课教室:">
                <el-select
                  v-model="searchInfo.classroom_id"
                  placeholder="请选择"
                  @change="handleSearch"
                  clearable
                >
                  <el-option
                    v-for="item in searchClassRoomList"
                    :key="item.classroom_id"
                    :label="item.name"
                    :value="item.classroom_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="排课课程:">
                <el-select
                  v-model.number="searchInfo.course_id"
                  filterable
                  clearable
                  placeholder="请选择课程"
                  :filter-method="
                    (queryString) => {
                      globalSearch(queryString, 'course');
                    }
                  "
                  @focus="globalSearch('', 'course')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in courseName"
                    :key="item.course_id"
                    :label="item.title"
                    :value="Number(item.course_id)"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="科目:">
                <el-select
                  v-model="searchInfo.subject_ids"
                  multiple
                  filterable
                  default-first-option
                  :filter-method="
                    (queryString) => {
                      globalSearch(queryString, 'subject');
                    }
                  "
                  placeholder="请选择"
                  @focus="globalSearch('', 'subject')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in subjectsList"
                    :key="item.subject_id"
                    :label="item.subject_title"
                    :value="item.subject_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="授课教师:">
                <common-staff-pull-down
                  :originId.sync="searchInfo.teacher_id"
                  :defaultSelected.sync="searchInfo.teacher_list"
                  :jobIds="[1]"
                  @change="handleSearch"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="点名人员:">
                <common-staff-pull-down
                  :originId.sync="searchInfo.staff_id"
                  :defaultSelected.sync="searchInfo.staff_list"
                  @change="handleSearch"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="点名时间:">
                <common-date-range-selector
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  v-model="searchInfo.roll_call_date"
                  @change="handleSearch"
                >
                </common-date-range-selector>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="班级类型:" prop="course_type">
                <el-radio-group
                  v-model="searchInfo.course_type"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">1vN</el-radio-button>
                  <el-radio-button :label="2">1v1</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="教务老师:" prop="t_staff_id">
                <common-staff-pull-down
                  :originId.sync="searchInfo.t_staff_id"
                  :defaultSelected.sync="searchInfo.t_staff_list"
                  :jobIds="[2]"
                  @change="handleSearch"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课耗状态:" prop="exceed_status">
                <el-radio-group
                  v-model="searchInfo.exceed_status"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">未超上</el-radio-button>
                  <el-radio-button :label="2">已超上</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="点名状态:" prop="status_type">
                <el-radio-group
                  v-model="searchInfo.status_type"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">正常</el-radio-button>
                  <el-radio-button :label="2">已撤销</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="星期:">
                <el-select
                  v-model="searchInfo.week_day"
                  filterable
                  placeholder="请选择"
                  @change="handleSearch"
                  clearable
                >
                  <el-option
                    v-for="item in weekList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
    </div>
    <div>
      <el-table
        size="mini"
        ref="mainTable"
        tooltip-effect="dark"
        v-horizontal-scroll
        style="width: 100%"
        :data="tableData"
        stripe
        @sort-change="handleSortChange"
      >
        <el-table-column label="学员姓名" prop="student.name" min-width="190">
          <template slot-scope="scope">
            <div
              class="mwow-green"
              style="
                cursor: pointer;
                display: flex;
                align-items: center;
                flex-wrap: nowrap;
              "
              v-if="scope.row.student"
              @click="toStudentDetail(scope.row)"
            >
              {{ scope.row.student.name }}
              <span v-if="scope.row.student_type === 1" class="typelab">
                临时
              </span>
              <span v-if="scope.row.student_type === 3" class="make-up-lessson">
                补课
              </span>
              <span v-if="scope.row.student_type === 5" class="typelabLearn">
                体验
              </span>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="签到状态" prop="student_status" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.student_status == 1" class="mwow-green">
              到课
            </span>
            <span v-if="scope.row.student_status == 2" class="mwow-gray">
              迟到
            </span>
            <span v-if="scope.row.student_status == 3" class="mwow-yellow">
              请假
            </span>
            <span v-if="scope.row.student_status == 4" class="mwow-red">
              未到课
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="点名时间"
          prop="roll_call_time"
          width="180"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div>
              {{ getTime(new Date(Number(scope.row.create_time + "000"))) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="点名状态">
          <template slot-scope="scope">
            {{ scope.row.status === 1 ? "正常" : "已撤销" }}
          </template>
        </el-table-column>
        <el-table-column label="点名人员" prop="staff.name"> </el-table-column>
        <el-table-column label="班级名称" prop="class.name"> </el-table-column>
        <el-table-column label="班级类型" prop="course_type" width="90">
          <template slot-scope="scope">{{
            scope.row.class.course_type === 1 ? "1vN" : "1v1"
          }}</template>
        </el-table-column>
        <el-table-column label="上课教室" prop="classroom.name">
          <template slot-scope="scope">{{
            scope.row.classroom ? scope.row.classroom.name : "-"
          }}</template>
        </el-table-column>
        <el-table-column label="排课课程" prop="course.title"></el-table-column>
        <el-table-column
          label="排课课时"
          prop="default_consume_number"
          width="90"
        ></el-table-column>
        <el-table-column
          label="上课时间"
          width="180"
          prop="lesson_full_start_time"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.class_lesson.date }}
              （周{{ scope.row.weekZh }}）
              {{
                scope.row.class_lesson.start_time &&
                scope.row.class_lesson.start_time.slice(0, 5)
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="授课教师">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.teacher_list
                  .map((item) => {
                    return item.name;
                  })
                  .join("、") || "-"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="教务老师" prop="edu_teacher.name" width="120">
          <template slot-scope="scope">
            <div>
              {{ scope.row.edu_teacher ? scope.row.edu_teacher.name : "-" }}
              <!--针对有编辑权限且距离点名时间在门店教务老师点名时间编辑有效期内   -->
              <i
                class="el-icon-edit-outline"
                style="cursor: pointer; font-size: 16px"
                @click="handleClickTeacher(scope.row)"
                v-if="isEditAuth && handleIsEditMaxDays(scope.row)"
              >
              </i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="耗课数" prop="real_consume_number">
          <template slot-scope="scope">
            {{ scope.row.real_consume_number }}
            <span class="mwow-red" v-if="scope.row.exceed_number > 0"
              >(超上{{ scope.row.exceed_number }}课时)</span
            >
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template slot="header">
            <div class="selfheader">
              <div>课消金额</div>
              <el-popover
                placement="top"
                width="190"
                popper-class="followuppopover"
                trigger="hover"
              >
                <p class="tipck">
                  仅统计课时消耗产生的课消金额，免费赠送不计算金额
                </p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope">
            <div>￥{{ scope.row.consume_amount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="上课内容"
          width="280"
          prop="class_lesson_extend.content"
          class-name="classCon"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.class_lesson_extend.content">
              {{ scope.row.class_lesson_extend.content }}
            </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="90">
          <template slot-scope="scope">
            <div class="operationBox" v-if="scope.row.status === 1">
              <div
                class="mwow-button primary"
                @click="lookDetailsrollist(scope.row)"
              >
                查看
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      v-if="loaded"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
    <edit-teacher-dialog
      :originId="rollCallStudentId"
      :visible="eidtDialogVisible"
      @change="handleEditChange"
    >
    </edit-teacher-dialog>
  </div>
</template>
<script>
import { dateFormat } from "@/utils/timeFormat";
import {
  staffList,
  getSelectClassList,
  getSelectCourseList,
  getSeleSubjectsList,
} from "@/api/globalSearch";
import { exportLoop } from "@/utils/export";
import { rollCallStudentList } from "@/api/rollCall";
import { exportRollList } from "@/api/rollCallRecord";
import { PageModule } from "@/store/module/page";
import { classroomSelectListApi } from "@/api/classRoom";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import editTeacherDialog from "./editTeacherDialog.vue";
import { UserModule } from "@/store/module/user";
import { staffCheckApi } from "@/api/makeUpLessons";

export default {
  components: {
    commonSearchFormWrapper,
    commonStaffPullDown,
    commonDateRangeSelector,
    editTeacherDialog,
  },
  props: ["teacherId", "studentName", "orderInfo", "visible"],
  data() {
    return {
      searchInfo: {
        exceed_status: -1,
        course_type: -1,
        student_status_list: [],
        sort_field: "lesson_full_start_time",
        sort_type: "desc",
        teacher_id: "",
        teacher_list: [],
        staff_id: "",
        staff_list: [],
        t_staff_id: "",
        t_staff_list: [],
        roll_call_date: [],
        lesson_date: [],
        status_type: -1,
        content: "",
        student_name: "",
      }, //搜索数据
      searchClassRoomList: [],
      tableData: [], //列表数据
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      staffName: "",
      courseName: "", //课程名字
      className: "", //班级名字
      staffList: [], //教务老师
      teacherName: "",
      subjectsList: [],
      loaded: false,
      eidtDialogVisible: false,
      rollCallStudentId: "",
      isEditAuth: false, // 是否有编辑权限
      weekList: [
        {
          key: 1,
          value: "周一",
        },
        {
          key: 2,
          value: "周二",
        },
        {
          key: 3,
          value: "周三",
        },
        {
          key: 4,
          value: "周四",
        },
        {
          key: 5,
          value: "周五",
        },
        {
          key: 6,
          value: "周六",
        },
        {
          key: 0,
          value: "周日",
        },
      ],
    };
  },
  computed: {
    isEditMaxDays() {
      return UserModule.userInfo.roll_call_edit_edu_teacher_max_days;
    },
  },
  created() {
    if (
      this.$route.query.name === "week" ||
      this.$route.query.name === "month"
    ) {
      this.searchInfo.lesson_date[0] = this.$route.query.s_time;
      this.searchInfo.lesson_date[1] = this.$route.query.e_time;
      this.searchInfo.teacher_id = Number(this.$route.query.tid);
    }
    if (this.$route.query.tid) {
      this.searchInfo.teacher_id = Number(this.$route.query.tid);
      this.searchInfo.status_type = 1;
    }
    if (this.$route.query.ts_n) {
      this.searchInfo.student_name = this.$route.query.ts_n;
    }
    if (this.$route.query.course_id) {
      this.searchInfo.course_id = Number(this.$route.query.course_id);
    }
    if (this.orderInfo.s_name) {
      this.searchInfo.student_name = this.orderInfo.s_name;
    }
    if (this.orderInfo.c_id) {
      this.searchInfo.course_id = Number(this.orderInfo.c_id);
    }
    if (this.orderInfo.ex_type) {
      this.searchInfo.exceed_status = Number(this.orderInfo.ex_type);
    }
    let from =
      localStorage.getItem("teacher-and-student-to-rollcall-student-list") ||
      [];
    if (from && from.length > 0) {
      this.searchInfo.teacher_list = JSON.parse(from);
      localStorage.removeItem("teacher-and-student-to-rollcall-student-list");
    }
    if (
      PageModule.latestRoute === "rollCallDetails" ||
      PageModule.latestRoute === "studyDetails"
    ) {
      // 内页返回
      const cache = PageModule.pageInfo.rollCallStudentList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    } else if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      if (this.$route.query.tab === "rollCallStudentList") {
        const params = this.$route.params;
        if (this.$route.params.type === "store-data") {
          this.searchInfo.lesson_date = [params.start_date, params.end_date];
          this.searchInfo.student_status_list = JSON.parse(
            params.student_status_list
          );
        }
        if (this.$route.params.type === "todo-list") {
          this.searchInfo.exceed_status = Number(params.exceed_status);
        }
      }
    } else if (PageModule.latestRoute === null) {
      // 新开页面或者刷新后
      // 来自工资绩效页
      const salaryCache = sessionStorage.getItem(
        "salary-achievements-link-to-rollcall-student-list"
      );
      if (salaryCache) {
        const cache = JSON.parse(salaryCache);
        if (cache.teacher_id && cache.teacher_name) {
          this.searchInfo.teacher_id = cache.teacher_id;
          this.searchInfo.teacher_list = [
            {
              staff_id: cache.teacher_id,
              name: cache.teacher_name,
            },
          ];
        }
        if (cache.lesson_date) {
          this.searchInfo.lesson_date = cache.lesson_date;
        }
        if (cache.student_status_list) {
          this.searchInfo.student_status_list = cache.student_status_list;
        }
        sessionStorage.removeItem(
          "salary-achievements-link-to-rollcall-student-list"
        );
      }
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      classroomSelectListApi({
        page: 1,
        page_size: 1000,
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchClassRoomList = res.data.list;
        }
      });
      staffCheckApi({
        api_path: ["/api/v1/class/lesson/roll_call/student/edit/edu_teacher"],
      })
        .then((res) => {
          if (res.error_code === 0) {
            this.isEditAuth =
              res.data[
                "/api/v1/class/lesson/roll_call/student/edit/edu_teacher"
              ];
          }
        })
        .catch(() => {
          this.isEditAuth = false;
        });
      this.handleSearch();
      if (this.searchInfo.course_id) {
        this.globalSearch("", "course");
      }
      if (this.searchInfo.class_id) {
        this.globalSearch("", "class");
      }
      if (this.searchInfo.subject_id) {
        this.globalSearch("", "subject");
      }
    },
    getTime(e) {
      const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
      const v = "（周" + weekZh[e.getDay()] + "）";
      const format = dateFormat("YYYY-mm-dd HH:MM", e);
      return format.slice(0, 10) + v + format.slice(11);
    },
    handleSortChange(data) {
      this.searchInfo.sort_field = data.prop;
      if (data.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (data.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.rollCallList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    // 导出开始
    clickexport() {
      const _t = this;
      const data = {};
      if (_t.searchInfo.sort_field) {
        data.sort_field = _t.searchInfo.sort_field;
      }
      if (_t.searchInfo.sort_type) {
        data.sort_type = _t.searchInfo.sort_type;
      }
      if (_t.searchInfo.roll_call_id) {
        data.roll_call_id = _t.searchInfo.roll_call_id;
      }
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.student_id) {
        data.student_id = _t.searchInfo.student_id;
      }
      if (_t.searchInfo.student_name) {
        data.student_name = _t.searchInfo.student_name;
      }
      if (
        _t.searchInfo.roll_call_date &&
        _t.searchInfo.roll_call_date.length === 2
      ) {
        data.roll_call_start_date = _t.searchInfo.roll_call_date[0];
        data.roll_call_end_date = _t.searchInfo.roll_call_date[1];
      }
      if (_t.searchInfo.lesson_date && _t.searchInfo.lesson_date.length === 2) {
        data.lesson_start_date = _t.searchInfo.lesson_date[0];
        data.lesson_end_date = _t.searchInfo.lesson_date[1];
      }
      if (_t.searchInfo.teacher_id) {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.course_id) {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.student_status) {
        data.student_status = _t.searchInfo.student_status;
      }
      if (_t.searchInfo.student_status_list) {
        data.student_status_list = _t.searchInfo.student_status_list;
      }
      if (_t.searchInfo.staff_id) {
        data.staff_id = _t.searchInfo.staff_id;
      }
      if (_t.searchInfo.subject_ids) {
        data.subject_ids = _t.searchInfo.subject_ids;
      }
      if (_t.searchInfo.course_type > -1) {
        data.course_type = _t.searchInfo.course_type;
      }
      if (_t.searchInfo.exceed_status > -1) {
        data.exceed_status = _t.searchInfo.exceed_status;
      }
      if (_t.searchInfo.t_staff_id) {
        data.edu_teacher_id = _t.searchInfo.t_staff_id;
      }
      if (
        _t.searchInfo.student_types &&
        _t.searchInfo.student_types.length > 0
      ) {
        data.student_types = _t.searchInfo.student_types;
      }
      if (_t.searchInfo.week_day === 0 || _t.searchInfo.week_day) {
        data.week_day = _t.searchInfo.week_day;
      } else {
        data.week_day = -1;
      }
      exportRollList(data).then((res) => {
        if (res.error_code == 0) {
          exportLoop(res.data.task_id);
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    savePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "rollCallStudentList",
        key: "search_info",
        value: this.searchInfo,
      });
      PageModule.SET_PAGE_INFO({
        name: "rollCallStudentList",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "rollCallStudentList",
        key: "page_size",
        value: this.pageSize,
      });
    },
    lookDetailsrollist(e) {
      const _t = this;
      this.savePageInfo();
      _t.$router.push({
        name: "rollCallDetails",
        query: { id: e.roll_call_id },
      });
    },
    toStudentDetail(row) {
      this.savePageInfo();
      this.$router.push({
        name: "studyDetails",
        query: {
          id: row.student.student_id,
          tab: "rollcall",
        },
      });
    },
    // 通用搜索框
    getSelectrList(e) {
      const _t = this;
      _t.globalSearch("", e);
    },
    getglobalsearchdata(data, type) {
      if (type == "staff") {
        return staffList(data);
      } else if (type == "teacher") {
        data.job_ids = [1];
        return staffList(data);
      } else if (type == "class") {
        return getSelectClassList(data);
      } else if (type == "course") {
        return getSelectCourseList(data);
      } else if (type == "subject") {
        return getSeleSubjectsList(data);
      }
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else if (type == "subject") {
          data.title = queryString;
        } else {
          data.key_word = queryString;
        }
      }
      if (type == "subject") {
        data.page_size = 500;
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;
      if (type == "staff") {
        _t.staffName = list;
      } else if (type == "teacher") {
        _t.teacherName = list;
      } else if (type == "class") {
        _t.className = list;
      } else if (type == "course") {
        _t.courseName = list;
      } else if (type == "subject") {
        _t.subjectsList = list;
      }
    },
    //上课记录
    rollCallList(data) {
      const _t = this;
      if (_t.searchInfo.sort_field) {
        data.sort_field = _t.searchInfo.sort_field;
      }
      if (_t.searchInfo.sort_type) {
        data.sort_type = _t.searchInfo.sort_type;
      }
      if (_t.searchInfo.roll_call_id) {
        data.roll_call_id = _t.searchInfo.roll_call_id;
      }
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.student_id) {
        data.student_id = _t.searchInfo.student_id;
      }
      if (_t.searchInfo.student_name) {
        data.student_name = _t.searchInfo.student_name;
      }
      if (
        _t.searchInfo.roll_call_date &&
        _t.searchInfo.roll_call_date.length === 2
      ) {
        data.roll_call_start_date = _t.searchInfo.roll_call_date[0];
        data.roll_call_end_date = _t.searchInfo.roll_call_date[1];
      }
      if (_t.searchInfo.lesson_date && _t.searchInfo.lesson_date.length === 2) {
        data.lesson_start_date = _t.searchInfo.lesson_date[0];
        data.lesson_end_date = _t.searchInfo.lesson_date[1];
      }
      if (_t.searchInfo.teacher_id) {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.course_id) {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.student_status) {
        data.student_status = _t.searchInfo.student_status;
      }
      if (_t.searchInfo.student_status_list.length > 0) {
        data.student_status_list = _t.searchInfo.student_status_list;
      }
      if (_t.searchInfo.staff_id) {
        data.staff_id = _t.searchInfo.staff_id;
      }
      if (_t.searchInfo.subject_ids && _t.searchInfo.subject_ids.length > 0) {
        data.subject_ids = _t.searchInfo.subject_ids;
      }
      if (_t.searchInfo.course_type > -1) {
        data.course_type = _t.searchInfo.course_type;
      }
      if (_t.searchInfo.exceed_status > -1) {
        data.exceed_status = _t.searchInfo.exceed_status;
      }
      if (_t.searchInfo.status_type > -1) {
        data.status = _t.searchInfo.status_type;
      }
      if (_t.searchInfo.classroom_id) {
        data.classroom_id = _t.searchInfo.classroom_id;
      }
      if (_t.searchInfo.t_staff_id) {
        data.edu_teacher_id = _t.searchInfo.t_staff_id;
      }
      if (
        _t.searchInfo.student_types &&
        _t.searchInfo.student_types.length > 0
      ) {
        data.student_types = _t.searchInfo.student_types;
      }
      if (_t.searchInfo.week_day === 0 || _t.searchInfo.week_day) {
        data.week_day = _t.searchInfo.week_day;
      } else {
        data.week_day = -1;
      }
      rollCallStudentList(data).then((res) => {
        if (res.error_code == 0) {
          res.data.list.map((item) => {
            item.weekZh = ["日", "一", "二", "三", "四", "五", "六"][
              item.week_day
            ];
          });
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
          if (!this.loaded) {
            this.loaded = true;
          }
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handleIsEditMaxDays(row) {
      let now = Date.now();
      let curCreateTime = row.create_time * 1000;
      let validDate = false; // 是否在有效时间
      if (now - curCreateTime < this.isEditMaxDays * 24 * 60 * 60 * 1000) {
        validDate = true;
      } else {
        validDate = false;
      }
      return validDate;
    },
    handleClickTeacher(row) {
      this.rollCallStudentId = row.roll_call_student_id;
      if (row.edu_teacher) {
        this.$confirm(
          "确认更改该学员课次点名记录的教务老师?变更后，会影响教务老师的业绩数据，请谨慎操作",
          "变更教务老师",
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
          }
        )
          .then(() => {
            this.eidtDialogVisible = true;
          })
          .catch(() => {});
      } else {
        this.eidtDialogVisible = true;
      }
    },
    handleEditChange(val) {
      this.eidtDialogVisible = false;
      this.rollCallStudentId = "";
      // 只有当 val 为 true 时，重新获取数据
      if (val) {
        this.rollCallList({
          page: this.page,
          page_size: this.pageSize,
        });
      }
    },
    handleSearch() {
      const _t = this;
      _t.rollCallList({
        page: 1,
        page_size: _t.pageSize,
      });
    },

    handleSearchReset() {
      this.searchInfo = {
        exceed_status: -1,
        course_type: -1,
        student_status_list: [],
        sort_field: "lesson_full_start_time",
        sort_type: "desc",
        teacher_id: "",
        roll_call_date: [],
        lesson_date: [],
        status_type: -1,
        content: "",
        student_name: "",
      };
      this.handleSearch();
    },
    handlePagerSizeChange(e) {
      const _t = this;
      _t.pageSize = e;
      _t.rollCallList({
        page: _t.page,
        page_size: _t.pageSize,
      });
    },
    handlePagerChange(e) {
      const _t = this;
      _t.page = e;
      _t.rollCallList({
        page: _t.page,
        page_size: _t.pageSize,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.searchBox {
  margin-top: 12px;
}
.selfheader {
  display: flex;
  align-items: center;
}
.FoUpBtn {
  color: #409eff;
}
.editBtn {
  color: #07d1aa;
}
.closeBtn {
  color: #ffb940;
}
.delBtn {
  color: #5c5d5e;
}
.red {
  color: #f56c6c;
}
.green {
  color: #07d1aa;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.orderChoose {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  .orderChooseSm {
    width: 40%;
    cursor: pointer;
    div {
      color: #5c5d5e;
      font-size: 14px;
      margin: 12px 0;
      text-align: center;
    }
    img {
      width: 100%;
      min-width: 140px;
      min-height: 94px;
    }
  }
}
//添加学员盒子
.drawer_box {
  padding: 0 5%;
}
.drawer_Head {
  font-size: 14px;
  color: #5c5d5e;
  margin-bottom: 14px;
}
.drawer_bottomBtn {
  display: flex;
  justify-content: flex-end;
  max-width: 380px;
  .reloadbtn {
    line-height: 22px;
    padding: 0;
    width: 44px;
    text-align: center;
  }
  .reloadbtn:nth-of-type(1) {
    margin-right: 10px;
  }
}
/deep/ .drawer_form {
  .drawer_chooseDate {
    background: #fff;
    .inputdate {
      width: 175px;
      .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
    }
    .inputyear {
      width: 85px;
      height: 28px;
      display: inline-block;
      text-align: center;
      border-radius: 0 4px 4px 0px;
      border: 1px solid #dcdfe6;
      vertical-align: middle;
      margin-left: -1px;
      text-align: center;
    }
  }
  .drawer_input {
    width: 260px;
    .el-input-group__prepend {
      background: #fff;
    }
  }
  .drawer_onlychoose {
    .el-input {
      width: 260px;
    }
  }
  .drawer_selectchoose {
    .el-input {
      width: 80px;
    }
    .el-input__inner {
      padding-left: 6px;
    }
  }
}

/deep/ .drawerLenan_name {
  .el-form-item__label {
    line-height: 44px !important;
  }
}
/deep/ .avatar-uploader {
  .el-upload {
    border: 1px dashed #e7e8ea;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
}
.avatar {
  width: 44px;
  height: 44px;
  display: block;
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
/deep/ .classCon {
  .cell {
    width: 23em;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*禁止换行*/
    text-overflow: ellipsis;
  }
}
.typelab,
.typelabLearn {
  width: 30px;
  height: 14px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  background: #e2f1ff;
  font-size: 12px;
  margin-left: 5px;
}
.typelabLearn {
  color: #bf90ff;
  background: #eee4ff;
}
.make-up-lessson {
  text-align: center;
  line-height: 14px;
  display: inline-block;
  width: 30px;
  height: 14px;
  border-radius: 4px;
  color: #666666;
  background-color: #e4e4e4;
  margin-left: 5px;
}
/deep/.form {
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 80px !important;
      text-align: right;
    }
    .el-form-item__content {
      width: 100%;
    }
  }
}
</style>
